import { colorVar } from '@/utils/colors';
import { Badge } from '@mantine/core';

export const StatusBadge = ({ isActive }: { isActive: boolean }) => {
  return isActive ? (
    <Badge
      fz={12}
      variant="dot"
      c="#55AD1A"
      bg="status-success"
      color="green"
      fw={400}
    >
      Active
    </Badge>
  ) : (
    <Badge
      fz={12}
      variant="dot"
      c="brand-grey-3"
      color="brand-grey-3"
      bg="brand-grey-2"
      fw={400}
    >
      Inactive
    </Badge>
  );
};
